import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, DialogActions, Alert } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import { useTranslation } from 'react-i18next';
import { MicrophoneService } from '../../../services/core';

interface MicrophonePrimerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * מבקש הרשאת מיקרופון פעם אחת, מיד אחרי סיור ההדרכה ולפני שהמשתמש
 * מגיע למסך השינון - כדי שבקשת ההרשאה של הדפדפן לא תקפוץ באמצע קריאה.
 * מסביר במפורש לבחור באפשרות הקבועה, כדי שלא נצטרך לשאול שוב.
 */
const MicrophonePrimerModal: React.FC<MicrophonePrimerModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [isRequesting, setIsRequesting] = useState(false);
  const [wasDenied, setWasDenied] = useState(false);

  const handleAllow = async () => {
    setIsRequesting(true);
    const granted = await MicrophoneService.requestPermission();
    setIsRequesting(false);

    if (granted) {
      onClose();
    } else {
      // נשארים במסך עם הסבר איך לתקן - אבל כבר לא נשאל שוב מעצמנו
      setWasDenied(true);
    }
  };

  const handleLater = () => {
    MicrophoneService.markPrimed();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleLater} className="microphone-primer-modal">
      <DialogTitle component="h3" sx={{ textAlign: 'center' }}>
        <MicIcon sx={{ color: 'white', fontSize: 64, background: '#5898ff', borderRadius: '50%', padding: '8px' }} />
        <div>{t('micPrimerTitle')}</div>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', padding: '24px', maxWidth: 460 }}>
        <div style={{ fontSize: '16px', lineHeight: '24px' }}>{t('micPrimerBody')}</div>

        {!wasDenied && (
          <Alert severity="info" sx={{ marginTop: 2, textAlign: 'start' }}>
            {t('micPrimerHint')}
          </Alert>
        )}

        {wasDenied && (
          <Alert severity="warning" sx={{ marginTop: 2, textAlign: 'start' }}>
            {t('micPrimerDenied')}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
        {!wasDenied && (
          <Button className="import-button" onClick={handleAllow} variant="contained" disabled={isRequesting}>
            {t('micPrimerAllow')}
          </Button>
        )}
        <Button onClick={handleLater} variant="text">
          {wasDenied ? t('micPrimerClose') : t('micPrimerLater')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MicrophonePrimerModal;
